<template>
    <div :class="classMarkers" role="row">
        <div role="cell" :id="getId(column, index)" v-for="(column, index) in columnData" :class="column.classMarkers" v-html="getRowDataValue(index)"></div>
        <slot></slot>
        <div class="col-12 px-0 d-xl-none" role="cell">
            <template v-for="(column, index) in columnData">
                <div v-if="rowDataValueNotEmpty(index)" :class="column.responsiveMarkers">
                    <div class="d-inline-flex col-12 col-md-3 px-0 method-value-hide-mobile">
                        <span class="theme-primary font-weight-bold d-inline-flex" v-bind:class="{ 'pr-1' : column.info !== null }">{{column.name}}</span>
                        <fa-icon v-if="column.info !== null" :icon="['fas','info-circle']" tabindex="0" class="theme-primary icon" aria-hidden="false" v-tooltip="column.info" />
                        <span class="font-weight-bold d-inline-flex">:</span>
                    </div>
                    <span class="d-inline-flex col-12 col-md-9 px-0 mb-3 mt-2 data-row-mobile-view" v-html="getRowDataValue(index)"></span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DataRow",

        props: {
            rowData: Object,
            columnData: Object,
            classMarkers: String,
            getId: {
                type: Function,
                default: () => null
            }
        },

        methods: {
            getRowDataValue: function(index) {
                return this.rowData[index].columnValue;
            },

            rowDataValueNotEmpty: function(index) {
                return this.rowData[index].columnValue !== "";
            }
        }
    }
</script>

<style scoped>
    .row {        
        display: flex;
        align-items: center;
    }
    
    .account.row {
        border-bottom: 2px solid var(--account-row-border-color);
        padding: 1rem 0rem;
    }

    .row div {
        line-height: 1;
    }

    .data-row-mobile-view{
        line-height: 20px;
    }
    @media(max-width: 767px) {
    .delivery-method .method-value-hide-mobile{
        display: none !important;
      }
    }
</style>